import {
  FilterChipsOptionsProps,
  STATUS_INDICATOR_VARIANTS,
} from "@cdkglobal/radial";
import { BULK_IMPORT_FIELD_KEYS } from "../../../constants";

export const MAX_FILE_SIZE = 5 * 1024 * 1024;

export const ALLOWED_TYPES = [
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "text/csv",
];

export enum UploadState {
  IDLE = "idle",
  VALIDATING = "validating",
  VALIDATION_COMPLETE = "validationComplete",
  IMPORTING = "importing",
  IMPORT_COMPLETE = "importComplete",
  PARSING_ERROR = "parsingError",
}

export const IMPORT_FILTER_OPTIONS: FilterChipsOptionsProps[] = [
  { label: "Success", value: "success" },
  { label: "Failed", value: "failure" },
  { label: "Aborted", value: "aborted" },
];

export const VALIDATE_FILTER_OPTIONS: FilterChipsOptionsProps[] = [
  { label: "Success", value: "success" },
  { label: "Failed", value: "failure" },
];

export const FILE_UPLOAD_STATE_CONFIG = {
  validationComplete: {
    headerTitle: "Validation Summary",
    statusField: BULK_IMPORT_FIELD_KEYS.RECORD_VALIDATION_STATUS,
    pinnedColumns: [
      {
        field: BULK_IMPORT_FIELD_KEYS.RECORD_VALIDATION_STATUS,
        headerName: "Validation Status",
      },
      {
        field: BULK_IMPORT_FIELD_KEYS.RECORD_VALIDATION_INFORMATION,
        headerName: "Validation Message",
      },
    ],
    filterOptions: VALIDATE_FILTER_OPTIONS,
  },
  importComplete: {
    headerTitle: "Upload Summary - Record Status Overview",
    statusField: BULK_IMPORT_FIELD_KEYS.RECORD_IMPORT_STATUS,
    pinnedColumns: [
      {
        field: BULK_IMPORT_FIELD_KEYS.RECORD_IMPORT_STATUS,
        headerName: "Import Status",
      },
      {
        field: BULK_IMPORT_FIELD_KEYS.RECORD_IMPORT_INFORMATION,
        headerName: "Import Information",
      },
    ],
    filterOptions: IMPORT_FILTER_OPTIONS,
  },
} as const;

export const STATUS_VARIANT_BY_LABEL = {
  success: STATUS_INDICATOR_VARIANTS.POSITIVE,
  failure: STATUS_INDICATOR_VARIANTS.NEGATIVE,
  aborted: STATUS_INDICATOR_VARIANTS.WARNING,
} as const;
